import { render } from "./UploadComponentImagem.vue?vue&type=template&id=02bc3cbb&scoped=true"
import script from "./UploadComponentImagem.vue?vue&type=script&lang=js"
export * from "./UploadComponentImagem.vue?vue&type=script&lang=js"

import "./UploadComponentImagem.vue?vue&type=style&index=0&id=02bc3cbb&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bc3cbb"]])

export default __exports__
import QFile from 'quasar/src/components/file/QFile.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QFile});
